import React from 'react';
import './BlockRenderer.css';

export type ContentBlock =
  | { id: string; type: 'richtext'; html: string }
  | { id: string; type: 'paragraph'; text: string }
  | { id: string; type: 'list'; items: string[] }
  | { id: string; type: 'image'; url: string; alt?: string };

interface BlockRendererProps {
  blocks: ContentBlock[];
}

function linkify(text: string): React.ReactNode[] {
  const parts = text.split(/(https?:\/\/[^\s]+)/g);
  return parts.map((part, i) =>
    /^https?:\/\//.test(part) ? (
      <a key={i} href={part} target="_blank" rel="noopener noreferrer">{part}</a>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    )
  );
}

export default function BlockRenderer({ blocks }: BlockRendererProps) {
  if (!Array.isArray(blocks) || blocks.length === 0) {
    return null;
  }

  return (
    <div className="block-renderer">
      {blocks.map((b) => {
        if (!b) return null;

        if (b.type === 'richtext') {
          return (
            <div
              key={b.id}
              className="block-richtext"
              dangerouslySetInnerHTML={{ __html: b.html }}
            />
          );
        }

        if (b.type === 'paragraph') {
          return (
            <p key={b.id} className="block-paragraph">
              {linkify(b.text)}
            </p>
          );
        }

        if (b.type === 'list') {
          return (
            <ul key={b.id} className="block-list">
              {b.items.filter(Boolean).map((item, idx) => (
                <li key={idx}>
                  {linkify(item)}
                </li>
              ))}
            </ul>
          );
        }

        if (b.type === 'image') {
          return (
            <div key={b.id} className="block-image">
              <img src={b.url} alt={b.alt || ''} />
            </div>
          );
        }

        return null;
      })}
    </div>
  );
}

